import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import PropTypes from 'prop-types';
import { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DialogEditSettingView from '../DialogEditSettingView';
import { thunkGetAppConfig } from 'app/appSlice';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';

GeneralSettingView.propTypes = {
    showFullUI: PropTypes.bool,
    prefKey: PropTypes.string,
};

function GeneralSettingView({ showFullUI, prefKey }) {
    // MARK: ---- PROPERTIES ----
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const appConfig = useAppConfig();
    const [settingList, setSettingList] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        setSettingList([
            {
                key: 'showShareRatio',
                name: 'Ẩn tỷ lệ góp vốn của NĐT HTKD',
                value: appConfig.showShareRatio ? 'Có' : 'Không',
                onClick: () => {
                    handleEditSetting(
                        'showShareRatio',
                        'Ẩn tỷ lệ góp vốn của NĐT HTKD',
                    )
                },
            },
            {
                key: 'productVatRate',
                name: 'Thuế suất VAT bán hàng (áp dụng cho đơn hàng sản phẩm, hiển thị khi thanh toán và ghi trên hóa đơn điện tử)',
                value: `${appConfig.productVatPercent}%`,
                onClick: () => {
                    handleEditSetting(
                        'productVatRate',
                        'Thuế suất VAT bán hàng',
                        'VAT',
                        '%',
                        false,
                        true,
                    )
                },
            },
            {
                key: 'productPricesIncludeVat',
                name: 'Giá sản phẩm niêm yết ĐÃ gồm VAT (chọn Không: VAT được cộng thêm vào giá khi thanh toán; chọn Có: khách trả đúng giá niêm yết, VAT nằm trong giá)',
                value: appConfig.productPricesIncludeVat ? 'Có (giá đã gồm VAT)' : 'Không (VAT cộng thêm vào giá)',
                onClick: () => {
                    handleEditSetting(
                        'productPricesIncludeVat',
                        'Giá niêm yết đã gồm VAT',
                    )
                },
            },
        ]);
    }, [appConfig]);

    useEffect(() => {
        setTotal(settingList.length);
    }, [settingList]);

    const columns = useMemo(() => [
        {
            id: 'NAME',
            name: UIHelper.buildTableColumn('Tên tác vụ'),
            selector: (row) => (
                <div className='p-1'>{row.name}</div>
            ),
            minWidth: '500px',
        },
        {
            id: 'CONTENT',
            name: UIHelper.buildTableColumn('Nội dung'),
            selector: (row) => (
                <div className='p-1'>{row.value}</div>
            ),
            width: '300px',
        },
        {
            name: UIHelper.buildTableColumn('Thao tác'),
            width: '100px',
            style: {
                position: 'sticky',
                right: 0,
                backgroundColor: '#fff',
                borderLeft: '1px solid #ebedfe',
            },
            cell: (row) => (
                <MenuActionDropdown
                    menuAction={[
                        {
                            iconElement: (
                                <i
                                    className="fa-regular fa-pen-to-square"
                                    style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                ></i>
                            ),
                            text: 'Sửa tác vụ',
                            click: () => {
                                row.onClick()
                            },
                            show: true,
                        },
                    ]}
                />
            ),
        },
    ], [settingList]);

    // MARK: ---- METHODS ----
    const handleRefresh = () => {
        dispatch(thunkGetAppConfig());
    }
    const handleEditSetting = (key, title, label, unit, isDropdown, isRequired) => {
        AppCustomDialogHelper.show(
            'Sửa tác vụ',
            <DialogEditSettingView
                item={appConfig}
                name={key}
                title={title}
                label={label}
                unit={unit}
                isDropdown={isDropdown}
                isRequired={isRequired}
                hasManyInput={Array.isArray(appConfig[key])}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'md',
            false,
            true,
        )
    }

    return (
        <div>
            {UIHelper.buildCard(
                <div>
                    <div className="pb-4">
                        <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                            <div className="d-flex flex-column">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    Cài đặt chung
                                </span>
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Tổng:{' '}
                                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                        {Utils.formatNumber(total)} bản ghi
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="px-4">
                                <KTTable
                                    columns={columns}
                                    items={settingList}
                                    selectableRows={false}
                                    striped={false}
                                    compactGrid={false}
                                    onClickedRow={() => { }}
                                    onSelectedRowsChanged={() => { }}
                                    onDoubleClickedRow={() => { }}
                                    noDataComponent={UIHelper.buildEmptyNoData(
                                        'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default GeneralSettingView;
